module.exports = __webpack_public_path__ + "img/landscape-phone.929a6661.svg";